import NotFound from '../Pages/layout/NotFound'; 
import React from 'react';
import { useLocation, Route, Routes } from 'react-router-dom';

const NotFoundRoute = () => {
  const location = useLocation();

  const isRoute = [
    '/', 
    '/sec/log-in',
    '/sec/create-account',
    '/sec/forgot-password',
    '/sec/verify',
    '/sec/verify/:token',
    '/sec/reset-password/:token',
    '/p/profile',
    '/your-orders',
    '/p/cart',
    '/p/check-out',
    '/p/favorites',
    '/p/track/:orderId',
    '/p/review/:orderId',
    '/merchant/:id',
    '/merchant/:id/product/:spId',
    '/faqs',
    '/support',
    '/terms-and-conditions',
    '/end-user-license-agreement',
    '/return-refund-policy',
    '/privacy-policy',
    '/others',
    '/p/orders/:orderId/:refId',
    '/p/orders',
    '/search',
    '/thank-you-for-your-order',
    '/:categoryName',
    '/g-search',
    '/s/:merchant_slug/:productCategoryName'
  ].some((path) => location.pathname.match(new RegExp(`^${path.replace(/:[^/]+/g, '[^/]+')}$`)));

  return !isRoute ? (
    <Routes>
      <Route path="*" element={<NotFound />} />
    </Routes>
  ) : null;
};

export default NotFoundRoute;
